import Link from 'next/link';

import styles from './buttonGroup.module.css';

const ButtonGroup = ({links}) => (
  <div className={styles.button_group_container}>
    {links.map((link) => {
      const className = link.text === 'UberEats' ? 'ubereats-theme' : '';
      return (
        <div key={link.text}>
          <Link
            href={link.src}
            target={`_blank`}
            className={`custom__button ${className}`}>
            {link.text}
          </Link>
        </div>
      );
    })}
  </div>
);

export default ButtonGroup;
